import { Calendar, Clock, Plus } from 'lucide-react';
import { cardBase, ViewAllLink } from './dashboardUtils';

export function ShowingsWidget({ showings, onAddShowing }) {
  return (
    <div className={`${cardBase} overflow-hidden`} data-testid="dashboard-upcoming-showings">
      <div className="flex items-center justify-between px-6 pt-5 pb-3">
        <h2 className="text-[15px] font-semibold text-gray-900 flex items-center gap-2">
          <Calendar className="h-4 w-4 text-teal-500" /> Upcoming Showings
          {showings.length > 0 && (
            <span className="text-[11px] font-medium text-gray-400 bg-gray-100 rounded-full px-2 py-0.5 tabular-nums">{showings.length}</span>
          )}
        </h2>
        <div className="flex items-center gap-1.5">
          {onAddShowing && (
            <button
              type="button"
              onClick={onAddShowing}
              className="inline-flex items-center gap-1 text-[11px] font-medium text-teal-700 hover:text-teal-800 hover:bg-teal-50 px-1.5 py-0.5 rounded"
              data-testid="dashboard-add-showing-btn"
              title="Add a new showing"
            >
              <Plus className="h-3 w-3" /> Add
            </button>
          )}
          <ViewAllLink to="/leads" label="showings" />
        </div>
      </div>
      <div className="px-6 pb-5">
        {showings.length === 0 ? (
          <p className="text-[13px] text-gray-400 py-2">No showings in the next 2 weeks</p>
        ) : (
          <div className="space-y-0">
            {showings.map((s, i) => {
              const fmtShowDate = (() => {
                try {
                  const d = new Date(s.date + 'T00:00:00');
                  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
                } catch { return s.date; }
              })();
              const fmtShowTime = (() => {
                try {
                  const [h, m] = s.time.split(':');
                  const hr = parseInt(h);
                  const ampm = hr >= 12 ? 'PM' : 'AM';
                  return `${hr > 12 ? hr - 12 : hr || 12}:${m} ${ampm}`;
                } catch { return s.time; }
              })();
              return (
                <div key={s.showing_id || i} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0" data-testid={`showing-row-${s.showing_id}`}>
                  <div>
                    <p className="text-[13px] font-medium text-gray-900">{s.lead_name}</p>
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className="text-[11px] text-gray-400 tabular-nums">{fmtShowDate}</span>
                      <span className="flex items-center gap-1 text-[11px] text-gray-500">
                        <Clock className="h-3 w-3" />{fmtShowTime}
                      </span>
                    </div>
                  </div>
                  {s.lead_phone && (
                    <span className="text-[11px] text-gray-400">{s.lead_phone}</span>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
